const baseURL = window.location.pathname

export const useBaseURL = () => {
  return {
    baseURL,
  }
}
